import React, { useMemo } from "react";
import LoadingSpinner from "../../../../externalComponents/LoadingSpinner";
import { Text } from "../../../../externalComponents/tailwind/text";
import KeyValueList from "../../../../externalComponents/KeyValueList";

export default function ContactInformationsTags({ data, fetching }) {
  const tags = useMemo(() => {
    if (!data) {
      return [];
    }
    return data
      .filter((contactTag) => contactTag?.tag)
      .map((contactTag) => contactTag.tag.name)
      .sort((a, b) => (a || "").localeCompare(b || ""));
  }, [data]);

  return (
    <>
      <Text className="font-bold mt-5 mb-3">Tags</Text>
      {fetching ? (
        <LoadingSpinner />
      ) : tags?.length ? (
        <>
          <KeyValueList data={tags} />
        </>
      ) : (
        <div className="text-gray-400 text-xs font-medium">No tags found</div>
      )}
    </>
  );
}
